import { useRef, useEffect } from 'react';
import { useFields } from './Fields.Context';
import type { FieldsProviderProps } from './Fields.Context';
import { FieldsEditor } from './Fields.Editor';
import { useRecoilValue } from 'recoil';
import { reportStatusState, ADDENDUM_EDITOR_EDITABLE_STATUSES, ReportStatuses } from '../state';

export const FieldsAddendumEditor = ({
  isDisabled,
  isClaimedByMe,
  onInit,
}: Readonly<{
  isDisabled: boolean;
  isClaimedByMe: boolean;
  onInit?: FieldsProviderProps['onInit'];
}>): React.ReactElement | null => {
  const [{ addendum }, { onAddendumChange }] = useFields();
  const status = useRecoilValue(reportStatusState);
  const ref = useRef<HTMLDivElement>(null);
  const hasAddendum = addendum != null;

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [hasAddendum]);

  if (addendum == null || !isClaimedByMe) return null;

  return (
    <div ref={ref}>
      <FieldsEditor
        initialContent={addendum.content}
        onChange={onAddendumChange}
        isDisabled={
          isDisabled ||
          !(ADDENDUM_EDITOR_EDITABLE_STATUSES as Array<ReportStatuses>).includes(status)
        }
        onInit={onInit}
        variant="report"
        isAddendumEditor={true}
        label="New Addendum"
      />
    </div>
  );
};
